import { IOptionItem } from 'interfaces'
import { ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { StyleTabBtn } from 'styles/styledGlobal'

export const StyleContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const StyleWrapperItem = styled.ul`
  list-style-type: none;
  display: flex;
  padding: 0;
  margin: 0;
`

interface IProps {
  tabs?: Array<IOptionItem>
  tab?: IOptionItem
  tabValue?: string | number
  onChange?: (item: IOptionItem) => void
  showCount?: boolean
  children?: ReactNode
  className?: string
}

const TabButton = (props: IProps) => {
  const { t } = useTranslation()
  const { tabs, tab, tabValue, onChange, showCount, children, className } =
    props
  const [tabPrivate, setTabPrivate] = useState(tabs?.[0])

  const handleOnChange = (item: IOptionItem) => {
    setTabPrivate(item)
    if (onChange) onChange(item)
  }

  const tabSelected =
    tab || tabs?.find((tab) => tab.value == tabValue) || tabPrivate

  return (
    <>
      <StyleWrapperItem className={className}>
        {tabs?.map((item) => (
          <StyleTabBtn
            key={item.label?.toString()}
            className={tabSelected?.label === item.label ? 'active' : ''}
            onClick={() => handleOnChange(item)}>
            {t(item.label?.toString() || '')}
            {showCount && item.count !== undefined ? `(${item.count})` : ''}
          </StyleTabBtn>
        ))}
      </StyleWrapperItem>
      {children}
    </>
  )
}

export default TabButton

interface IPropsButtonItem {
  children: ReactNode
  tab: string | number
  tabSelected: string | number
  className?: string
}
export const TabButtonItem = ({
  children,
  tab,
  tabSelected,
  className
}: IPropsButtonItem) => {
  if (tab != tabSelected) return <></>
  return <div className={className}>{children}</div>
}
